import { Avatar } from '@mui/material'
import type { TodoUser } from './Tododata.ts'

export default function UserAvatar({ user, size = 28 }: { user?: TodoUser; size?: number }) {
  if (!user) return <Avatar sx={{ width: size, height: size, bgcolor: '#C9C6B2', fontSize: size * 0.42 }}>?</Avatar>
  return (
    <Avatar
      title={user.name}
      src={user?.profileUrl}
      sx={{ width: size, height: size, bgcolor: user.color, color: '#fff', fontSize: size * 0.42, fontWeight: 700 }}
    >
      {user.initials}
    </Avatar>
  )
}